import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkGetTriageRequestByNoteId } from '../types';

const onGetTriageRequestByNoteId: IThunkGetTriageRequestByNoteId = thunk(
  // @ts-ignore
  async ({ setTriageRequest, resetTriageRequest }, noteId) => {
    resetTriageRequest();
    const { data } = await api.triage.getRequestByNoteId(noteId);

    setTriageRequest(data);
  },
);

export default onGetTriageRequestByNoteId;
